import styled from 'styled-components';
import { Box } from '@99designs/emu';
import { maxWidths } from '@99designs/emu/settings';

type Props = {
    children: React.ReactNode;
};

const StyledBox = styled(Box)`
    .max--widescreen & {
        max-width: ${maxWidths.content['widescreen']}px;
    }
    .max--desktop & {
        max-width: ${maxWidths.content['desktop']}px;
    }
`;

export function GridLayout({ children }: Props) {
    return (
        <StyledBox
            margin="auto"
            paddingLeft={['1bu', '2bu', '2bu', '2bu']}
            paddingRight={['1bu', '2bu', '2bu', '2bu']}
        >
            {children}
        </StyledBox>
    );
}
